// extracted by mini-css-extract-plugin
export var btn = "newCalculator-module--btn--rnsKq";
export var btnCustomColor = "newCalculator-module--btnCustomColor--Z9ljd";
export var card = "newCalculator-module--card--LrO8L";
export var cardImg = "newCalculator-module--cardImg--mIgjL";
export var cardText = "newCalculator-module--cardText--Lw9kp";
export var container = "newCalculator-module--container--M2Po6";
export var content = "newCalculator-module--content--x+3Ef";
export var descr = "newCalculator-module--descr--IeJpf";
export var disclaimer = "newCalculator-module--disclaimer--Ri0qz";
export var head = "newCalculator-module--head--XcKCX";
export var link = "newCalculator-module--link--BlLmq";
export var plait = "newCalculator-module--plait--jF4Sv";
export var rail = "newCalculator-module--rail--QlNXy";
export var section = "newCalculator-module--section--Kwip2";
export var slider = "newCalculator-module--slider--oSU52";
export var sliderContainer = "newCalculator-module--sliderContainer---LuIJ";
export var sliderDescr = "newCalculator-module--sliderDescr--QZNsQ";
export var sliderSum = "newCalculator-module--sliderSum--PGZsY";
export var sum = "newCalculator-module--sum--8Va6i";
export var thumb = "newCalculator-module--thumb--AWwg+";
export var track = "newCalculator-module--track--Q8ei+";